/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// These values are also defined on lib/validators/birth_year_validator.rb
const MINIMUM_AGE = 13;
const MAXIMUM_AGE = 115;

window.fixYear = function(year) {
  year = parseInt(year && year.replace(/[^\d]/g, ''));
  if (isNaN(year) || (year === null)) { return ""; }
  if (year > 99) { return year; }
  if (year > (new Date().getFullYear() - 2000)) { return year + 1900; } else { return year + 2000; }
};

window.ClientSideValidations.validators.local['birth_year'] = function(element, options) {
  const rawYear = parseInt(element.val());
  const fixedYear = fixYear(element.val());

  if (rawYear !== fixedYear) { element.val(fixedYear); }

  if (fixedYear) {
    const age = new Date().getFullYear() - fixedYear;
    if (age < 0) {
      return {
        en: "We cannot sign up time travelers, sorry ;)",
        es: "No podemos registrar a viajeros del tiempo, lo sentimos ;)"
      }[CURRENT_LOCALE];
    }
    if (age < MINIMUM_AGE) {
      return {
        en: `You must be at least ${MINIMUM_AGE}-years-old`,
        es: `Debe tener al menos ${MINIMUM_AGE} años de edad`
      }[CURRENT_LOCALE];
    }
    if (age > MAXIMUM_AGE) {
      return {
        en: "Invalid year",
        es: "Año inválido"
      }[CURRENT_LOCALE];
    }
  } else {
     return {
       en: "Please use a four digit year",
       es: "Por favor use 4 dígitos para el año"
     }[CURRENT_LOCALE];
   }
};

/*
$(() => $('#user_birth_year').keyup(function() { return this.value = this.value.replace(/\D/g, '').substring(0, 4); }));
*/

function initValidationsOnLoad() {
  if ($('#user_birth_year').length) {
    $('#user_birth_year').keyup(function() { return this.value = this.value.replace(/\D/g, '').substring(0, 4); });
  }
}

$(initValidationsOnLoad);
document.addEventListener('turbo:load', initValidationsOnLoad);
